import { Component, OnInit, OnDestroy } from '@angular/core';
import { LiftService } from '../../services/lift.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LiftList } from '../../models/lift-list.model';
import { EntityDatatableComponent } from '../../../core/components/entity-datatable/entity-datatable.component';
import { LiftCriteria } from '../../models/lift.criteria';
import { EntityListRefresh } from '../../../core/services/entity-list.refresh';
import { ProgressBarService } from '../../../core/services/progress-bar.service';
import * as moment from 'moment';
import { LoginService } from 'src/app/user/services/login.service';

@Component({
  selector: 'app-lift',
  templateUrl: './lift.component.html',
  styleUrls: ['./lift.component.css']
})
export class LiftComponent extends EntityDatatableComponent<LiftList, LiftCriteria, LiftService> implements OnInit, OnDestroy {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    liftService: LiftService,
    entityListRefresh: EntityListRefresh,
    progressBarService: ProgressBarService
  ) {
    super(
      'lift',
      new LiftCriteria(),
      entityListRefresh,
      liftService,
      progressBarService
    );

    this.sortItems = [
      {
        title: 'lift.code',
        code: 'LiftModuleCode',
        sortOrder: 'asc',
        width: 156,
        disabled: false,
        isEmpty: false,
        class: null
      },
      {
        title: 'lift.town',
        code: 'AddressTown',
        sortOrder: 'asc',
        width: 150,
        disabled: false,
        isEmpty: false,
        class: null
      },
      {
        title: 'lift.street',
        code: 'AddressStreet',
        sortOrder: 'asc',
        width: 150,
        disabled: false,
        isEmpty: false,
        class: null
      },
      {
        title: 'lift.description',
        code: 'Description',
        sortOrder: 'asc',
        width: 180,
        disabled: false,
        isEmpty: false,
        class: 'd-none d-xl-table-cell'
      },
      {
        title: 'lift.floorCounts',
        code: 'FloorCount',
        sortOrder: 'asc',
        width: 100,
        disabled: false,
        isEmpty: false,
        class: 'd-none d-md-table-cell'
      },
      {
        title: 'lift.makeAt',
        code: 'MadeAt',
        sortOrder: 'asc',
        width: 100,
        disabled: false,
        isEmpty: false,
        class: 'd-none d-xl-table-cell'
      },
      {
        title: 'lift.loadCapacity',
        code: 'LoadCapacity',
        sortOrder: 'asc',
        width: 100,
        disabled: false,
        isEmpty: false,
        class: 'd-none d-md-table-cell'
      },
      {
        title: 'lift.action',
        code: 'action',
        sortOrder: 'asc',
        width: 50,
        disabled: true,
        isEmpty: true,
        class: null
      }
    ];
  }

  ngOnInit() {
    this.initData(this.route.snapshot.data.lifts);
    //console.log(this.route.snapshot.data.lifts);
  }

  ngOnDestroy() {
    this.destroyData();
  }

  activeFilter(filterTerm: string) {
    this.criteria.filterActive = filterTerm;
    this.criteria.page = 1;
    this.reloadData();
  }

  search(term: string) {
    this.criteria.searchTerm = term;
    this.criteria.page = 1;
    this.reloadData();
  }

  createLift() {
    this.router.navigate([{ outlets: { modal: ['create-lift'] } }]);
  }

  goToDetail(id: number) {
    this.router.navigate([{ outlets: { modal: ['lift-detail', id] } }]);
  }

  goToHistory(id: number) {
    this.router.navigate([{ outlets: { history: ['history', id] } }]);
  }

  formatMadeAt(madeAt: string) {
    if (!madeAt) {
      return '-';
    }
    const lastLogin = moment(madeAt);
    return lastLogin.format('DD.MM.YYYY HH:mm');
  }

  get isSuperadmin() {
    return this.loginService.isSuperadmin();
  }

  get isAdmin() {
    return this.loginService.isAdmin();
  }
}
